import { Form, Input, Select } from 'antd';

import { useCreateBranch, useUsers } from '../../hooks';
import { removeObjectProperties } from '../../utils';
import { Card, FormActions, FormSkeleton, PageHeader } from '../../components';
import { ROUTE_URLS } from '../../routes';
import { useI18n } from '../../i18n';

export const CreateBranch = () => {
  const { t } = useI18n();
  const { isLoading, mutateAsync: createBranch } = useCreateBranch();
  const { data: users, isLoading: usersLoading } = useUsers();

  const onFinish = values => {
    const readyValues = removeObjectProperties(values, ['productName']);
    createBranch(readyValues);
  };

  return (
    <div className='wm-form-page wm-form-page--narrow'>
      <PageHeader
        backTo={ROUTE_URLS.BRANCHES}
        backLabel={t('nav.branches')}
        title={t('branches.createTitle')}
        subtitle={t('branches.createSubtitle')}
      />
      <Form name='fields' layout='vertical' onFinish={onFinish} requiredMark={false}>
        <Card>
          {usersLoading ? (
            <FormSkeleton fields={2} />
          ) : (
            <BranchFields users={users} />
          )}
        </Card>
        <FormActions cancelTo={ROUTE_URLS.BRANCHES} submitting={isLoading} />
      </Form>
    </div>
  );
};

export const BranchFields = ({ users }) => {
  const { t } = useI18n();
  return (
    <>
      <Form.Item label={t('branches.name')} name='name' rules={[{ required: true, whitespace: true }]}>
        <Input placeholder={t('branches.namePlaceholder')} autoFocus />
      </Form.Item>
      <Form.Item label={t('branches.staff')} name='user_ids' rules={[{ required: true }]} style={{ marginBottom: 4 }}>
        <Select
          showSearch
          mode='multiple'
          optionFilterProp='label'
          placeholder={t('branches.staffPlaceholder')}
          options={(users ?? []).map(user => ({ value: user.id, label: user.login }))}
        />
      </Form.Item>
    </>
  );
};
